import { SxProps, Theme } from '@mui/material/styles';

import { getMonthWeeksMinHeightPx } from '@/shared/ui/calendarMonthMinHeight';

export const DAY_CELL_GAP_PX = 4;

const MONTH_WEEKS_MIN_HEIGHT_PX = getMonthWeeksMinHeightPx(36);

export const getDayCalendarSx = (columnGap: string): SxProps<Theme> => ({
  width: '100%',
  gap: columnGap,
  '& .MuiDateRangeCalendar-monthContainer:not(:last-of-type)': {
    borderRight: 'none',
  },
  '& .MuiPickersDay-root, & .MuiDayCalendar-weekDayLabel': {
    fontFamily: 'Neue Frutiger World',
    fontStyle: 'normal',
  },
  '& .MuiDayCalendar-header': {
    gap: `${DAY_CELL_GAP_PX}px`,
    marginBottom: '8px',
  },
  '& .MuiDayCalendar-weekDayLabel': {
    width: '40px',
    height: '20px',
    margin: 0,
    fontSize: '12px',
    lineHeight: 1.25,
    color: (theme) => theme.palette.grey[700],
  },
  '& .MuiDayCalendar-weekContainer': {
    gap: `${DAY_CELL_GAP_PX}px`,
    marginBottom: 0,
  },
  '& .MuiDayCalendar-weekContainer:not(:last-of-type)': {
    marginBottom: '8px',
  },
  '& .MuiPickersDay-hiddenDaySpacingFiller': {
    width: '40px',
    height: '36px',
    margin: 0,
  },
  '& .MuiDayCalendar-monthContainer': {
    position: 'static',
    height: 'auto',
    minHeight: `${MONTH_WEEKS_MIN_HEIGHT_PX}px`,
    overflow: 'visible',
  },
  '& .MuiDayCalendar-slideTransition': {
    height: 'auto',
    minHeight: `${MONTH_WEEKS_MIN_HEIGHT_PX}px`,
    overflow: 'visible',
  },
  '& .MuiPickersDay-root': {
    color: (theme) => theme.palette.grey[950],
  },
});
